import { render } from "./LoadingSpinnerHub.vue?vue&type=template&id=90967be4&scoped=true"
const script = {}

import "./LoadingSpinnerHub.vue?vue&type=style&index=0&id=90967be4&lang=scss&scoped=true"

import exportComponent from "/Users/patrykslak/Documents/lauron-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90967be4"]])

export default __exports__